import React, { useState, useEffect, useContext } from "react";
import Actual, { IActual } from "../../services/api/Actual";
import Year, { IYear } from "../../services/api/Year";
import Month, { IMonth } from "../../services/api/Month";
import Select from "../../components/Form/Select";
import GroupList from "./components/GroupList";
import ContentHeader from "../../components/ContentHeader";
import { ReactComponent as AtlasLatamLogo } from "../../components/ContentHeader/assets/images/actual.svg";
import Loading from "../../components/Loading";
import "./components/assets/css/colors.css";
import "./components/assets/css/form.css";

import AuthContext from "../../contexts/AuthContext";

const ActualUpdate: React.FC = () => {
  const { user } = useContext(AuthContext);
  const [actual, setActual] = useState<IActual[]>([]);
  const [years, setYears] = useState<IYear[]>([]);
  const [months, setMonths] = useState<IMonth[]>([]);
  const [loading, isLoading] = useState<Boolean>(true);

  const [year, setYear] = useState<Number>(0);
  const [month, setMonth] = useState<Number>(0);

  const date = new Date();
  // Se o mês for janeiro (0), ajusta para dezembro do ano anterior
  if (date.getMonth() === 0) {
    date.setFullYear(date.getFullYear() - 1);  // Ajusta o ano para o anterior
    date.setMonth(11);  // Define o mês como dezembro (11)
  } else {
    date.setMonth(date.getMonth() - 1);  // Subtrai 1 do mês, caso não seja janeiro
  }

  async function LoadActual(year: Number, month: Number) {
    const response: IActual[] = await Actual.GetAll(year, month);
    setActual(response);
  }

  useEffect(() => {
    Promise.all([Year.GetAll(), Month.GetAll()])
      .then((value) => {
        const years = value[0].filter((value) => { return value.active });
        setYears(years);
        setMonths(value[1]);

				setYear(date.getFullYear());
        setMonth(date.getMonth() + 1);

        LoadActual(years[0].name, date.getMonth() + 1);

        isLoading(false);
      })
      .catch(() => undefined);
  }, []);

  useEffect(() => {
    if (!loading) LoadActual(year, month);
  }, [year, month]);

  function list(obj: any): any {
    return { value: obj.id, label: obj.name };
  }

  return (
    <main className="wrapperApp">
      <ContentHeader
        title="Actual Update"
        Icon={AtlasLatamLogo}
        breadcrumb={["Actual Update"]}
      />
      <div id="content">
        <section className="content__block">
          {loading ? (
            <Loading />
          ) : (
            <>
              <div className="content__header">
                <h2 className="content__title">INSERT OR EDIT UNIT DATA</h2>

                <div className="multi-selects">
                  <div className="content__select">
                    <Select
                      className="select-custom select-custom--medium select-custom--shadow"
                      name="month"
                      title="Month"
                      options={months.map(list)}
                      value={month}
                      disabled={user!.profile.name === "Sender"}
                      handleChange={(
                        event: React.FormEvent<HTMLSelectElement>
                      ) => {
                        setMonth(+event.currentTarget.value);
                      }}
                    />
                  </div>

                  <div className="content__select">
                    <Select
                      className="select-custom select-custom--medium select-custom--shadow"
                      name="year"
                      title="Year"
                      options={years.map((obj) => {
                        return { value: obj.name, label: obj.name };
                      })}
                      value={year}
                      disabled={user!.profile.name === "Sender"}
                      handleChange={(
                        event: React.FormEvent<HTMLSelectElement>
                      ) => {
                        setYear(+event.currentTarget.value);
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="groups edit__buttons">
                <GroupList data={actual} year={year} month={month} />
              </div>

              <div className="actualColors">
                <div className="actualColors__wrapper">
                  <span className="actualColors__dot actualColors__dot--pendding"></span>
                  <span className="actualColors__text">Pending</span>
                </div>
                <div className="actualColors__wrapper">
                  <span className="actualColors__dot actualColors__dot--approved"></span>
                  <span className="actualColors__text">Approved</span>
                </div>
                <div className="actualColors__wrapper">
                  <span className="actualColors__dot actualColors__dot--revision"></span>
                  <span className="actualColors__text">
                    Waiting for approval
                  </span>
                </div>
                <div className="actualColors__wrapper">
                  <span className="actualColors__dot actualColors__dot--reproved"></span>
                  <span className="actualColors__text">
                    Adjustment needed
                  </span>
                </div>
              </div>
            </>
          )}
        </section>
      </div>
    </main>
  );
};

export default ActualUpdate;
